// extracted by mini-css-extract-plugin
export default {"figure":"mission_vision_figure__ROxPD","txt":"mission_vision_txt__K0Wws","phone_txt":"mission_vision_phone_txt__McInd"};